
import { useOktaAuth } from '@okta/okta-react';
import { Spinner } from 'react-bootstrap';
import { Navigate, Outlet } from 'react-router';

const RequireAuth = () => {
  const { authState } = useOktaAuth();

    if (!authState)
    {
      return  (
        <div style={{ height: "500px", width: "100%", lineHeight: "500px", textAlign: "center" }}>
          <Spinner animation="border" role="status" variant="primary" />
        </div>
      )
  
    }
    
    return <div>{(authState?.isPending || !authState?.isAuthenticated) ? <Navigate to="/login" replace /> : <Outlet />}</div>
 
  }




export default RequireAuth;